import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import './index.css';
import Anunt from './anunt/AnuntGeneral';
import AllAnunturi from './allAnunturi/AllAnunturi';
import Contact from './contact/Contact';
import Map from './Map';
import MapMobile from './MapMobile';
import AnunturiMobile from './AnunturiMobile';
import reportWebVitals from './reportWebVitals';
import Search from './search/Search';
import SearchResults from './search/SerchResults';

let savedJud = null;

// Pentru a afisa o alta componenta daca se foloseste ecran mic
function MapVersion() {
  const isMobile = window.innerWidth < 800;
  if ( isMobile ) {
    return <MapMobile />;
  }
  else {
    return <Map />;
  }
}

function MapVersionAnunturi() {
  const isMobile = window.innerWidth < 800;
  if ( isMobile ) {
    return <AnunturiMobile />;
  }
  else {
    return <Map />;
  }
}

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<MapVersion dropJud={savedJud} />} />
        <Route path="/anunturi" element={<MapVersionAnunturi dropJud={savedJud} />} />
        <Route path="/contact/mobile" element={<Contact />} />
        <Route path="/search/mobile" element={<Search />} />
        <Route path="/searchresults/mobile" element={<SearchResults />} />
        <Route path="/judet/:judet"           element={<AllAnunturi for='teren' licitatie={true} />} />
        <Route path="/anunturi/judet/:judet"  element={<AllAnunturi for='teren' licitatie={false} />} />
        <Route path="/case/judet/:judet"      element={<AllAnunturi for='casa'  licitatie={false} />} />
        <Route path="/anunt/case/:anuntId"              element={<Anunt for='casa'  licitatie={false} desktop={false} />} onClose={ (jud) => savedJud = jud } />
        <Route path="/anunt/case/desktop/:anuntId"      element={<Anunt for='casa'  licitatie={false} desktop={true}  />} onClose={ (jud) => savedJud = jud } />
        <Route path="/anunt/teren/:anuntId"             element={<Anunt for='teren' Licitatie={false} desktop={true}  />} onClose={ (jud) => savedJud = jud } />
        <Route path="/anunt/teren/desktop/:anuntId"     element={<Anunt for='teren' licitatie={false} desktop={true}  />} onClose={ (jud) => savedJud = jud } />
        <Route path="/licitatie/teren/:anuntId"         element={<Anunt for='teren' licitatie={true}  desktop={false} />} onClose={ (jud) => savedJud = jud } />
        <Route path="/licitatie/teren/desktop/:anuntId" element={<Anunt for='teren' licitatie={true}  desktop={true}  />} onClose={ (jud) => savedJud = jud } />
        <Route path="/licitatie/case/:anuntId"          element={<Anunt for='casa'  licitatie={true}  desktop={false} />} onClose={ (jud) => savedJud = jud } />
        <Route path="/licitatie/case/desktop/:anuntId"  element={<Anunt for='casa'  licitatie={true}  desktop={true}  />} onClose={ (jud) => savedJud = jud } />

        <Route path="/" element={<Navigate replace to="/" />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
